import { errorMessages } from 'commons/messages'
import { type CustomBoolean, TypesValidations } from 'constants/enums'

import { applyIntegerOrFloatPositiveNumberMask } from './mask'

const trim = (text: string) => text.trim()

const removeSpecialCharacters = (text: string) => text.replace(/[^\w\s]/gi, '').replace('_', '')

const trimTextOnlySpaces = (text: string) => {
  let newValue = text
  if (!text.replace(/\s/g, '').length) {
    newValue = trim(text)
  }
  return newValue
}

const removeLetters = (value: string) => value.replace(/\D+/g, '')

const removeNoDigits = (value: string) => {
  let newValue = removeSpecialCharacters(value)
  newValue = removeLetters(newValue)
  return newValue
}

const toFirsLetterUpper = (word: string) => {
  return word
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match: string, index: number) {
      if (/\s+/.test(match)) return ' '
      return index === 0 ? match.toUpperCase() : match.toLowerCase()
    })
}

/** @deprecated Use `capitalize` instead.
 * toAllFirstLetterUpper is less efficient than capitalize */
const toAllFirstLetterUpper = (str: string) => {
  let phrase = ''
  const words = str.toLowerCase().split(' ')
  words.forEach((word: string, index: number) =>
    index === words.length - 1
      ? (phrase = phrase + toFirsLetterUpper(word))
      : (phrase = phrase + toFirsLetterUpper(word) + ' '),
  )
  return phrase
}

// NOTE: More efficient than toAllFirstLetterUpper
const capitalize = (str: string) => {
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
}

const getValueDiscount = (value: string) => {
  return parseInt(value.replace(/^[a-z0]{1,100}$/, ''))
}

const convertBooleanApiValue = (value: CustomBoolean) => {
  return value === TypesValidations.YES
}

const errorMessagesValidation = (value: string, minumumValue?: number) => {
  const requiredFiledValidation = value.length <= 0 ? errorMessages.emptyField : ''
  const minumumValueValidation =
    value.length <= 0
      ? errorMessages.emptyField
      : value.length >= (minumumValue || 4)
        ? ''
        : errorMessages.invalidField
  return minumumValue ? minumumValueValidation : requiredFiledValidation
}

const verifyDiscount = (value: string): number => {
  let newValue = value.replace('.', ',') // TODO: Create utils function to replace decimal separator
  newValue =
    newValue.toString() === '0'
      ? applyIntegerOrFloatPositiveNumberMask(newValue?.replace('0', ''))
      : applyIntegerOrFloatPositiveNumberMask(newValue)

  let valueDiscount = parseFloat(newValue?.replace(',', '.')) // TODO: Create utils function to replace decimal separator

  if (isNaN(valueDiscount) || !valueDiscount.toString().length) {
    valueDiscount = 0
  } else if (valueDiscount > 99.99) {
    valueDiscount = 99.99
  }

  return valueDiscount
}

function isValidNumber(value: string) {
  return /^-?\d+$/.test(value)
}

const isValidDecimalString = (value: string): boolean => /^\d+(,|\.)?\d*$/.test(value)
const decimalStringToNumber = (value: string): number => Number(value.replace(',', '.')) // TODO: Create utils function to replace decimal separator

const formatNumber = (value: string) => value.replace(/[^\d.,]+/g, '')
const truncateString = (str: string, num: number) => {
  let format = ''
  if (!str) {
    return str
  }
  if (Array.isArray(str)) {
    format = str.join(' ')
  } else {
    format = str
  }
  if (format?.length <= num) {
    return format
  }
  return `${format.slice(0, num)}...`
}
const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

const isValidDomainEmail = (email: string): boolean => {
  const regex = /^[^\s@]+@(?!alpargatas\.|ioasys\.)[^\s@]+\.[^\s@]+$/

  return regex.test(email)
}

const removeDiacritics = (text: string): string => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const removeDiacriticsAndSpecialCharacters = (text: string): string => {
  return removeSpecialCharacters(removeDiacritics(text))
}

const formatCnpj = (cnpj: string): string => {
  if (!cnpj) return ''

  const rawCnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '')
  return rawCnpj.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
    '$1.$2.$3/$4-$5',
  )
}

const splittingString = (value: string, separator = ','): string[] => {
  return value.trim().length > 0 ? value.split(separator) : []
}

function padZeros(value: number | string, amount: number, side: 'LEFT' | 'RIGHT' = 'LEFT'): string {
  const str = String(value)
  const zeros = '0'.repeat(Math.max(0, amount))

  return side === 'RIGHT' ? str + zeros : zeros + str
}

const decodeArrayBufferToString = (value: ArrayBuffer): string => {
  const decoder = new TextDecoder('utf-8')
  return decoder.decode(value)
}

export {
  capitalize,
  convertBooleanApiValue,
  decimalStringToNumber,
  decodeArrayBufferToString,
  errorMessagesValidation,
  formatCnpj,
  formatNumber,
  getValueDiscount,
  isValidDecimalString,
  isValidDomainEmail,
  isValidNumber,
  padZeros,
  removeDiacritics,
  removeDiacriticsAndSpecialCharacters,
  removeLetters,
  removeNoDigits,
  removeSpecialCharacters,
  splittingString,
  toAllFirstLetterUpper,
  toFirsLetterUpper,
  toTitleCase,
  trim,
  trimTextOnlySpaces,
  truncateString,
  verifyDiscount,
}
